import moment from 'moment';
import BaseService from '../../../services/BaseService';

export const labelTipoRepasse = (tipo) => {
  if (tipo === 'ENTREGA') return 'Entrega';
  if (tipo === 'DEVOLUCAO') return 'Devolução';
  return tipo || '—';
};

export const formatDataHistorico = (value) => {
  if (!value) return '—';
  const parsed = moment(value);
  return parsed.isValid() ? parsed.format('DD/MM/YYYY HH:mm') : '—';
};

export const agruparUnidades = (historico) => {
  const ordem = [];
  const porEquipamento = new Map();
  (historico || []).forEach((evento) => {
    const chave = evento?.equipamentoId || evento?.numPatrimonio || evento?.historicoEquipamentoId;
    if (!chave) return;
    if (!porEquipamento.has(chave)) {
      porEquipamento.set(chave, []);
      ordem.push(chave);
    }
    porEquipamento.get(chave).push(evento);
  });
  return ordem.map((chave) => {
    const eventos = porEquipamento.get(chave);
    const referencia = eventos[0] || {};
    return {
      equipamentoId: referencia.equipamentoId || null,
      numPatrimonio: referencia.numPatrimonio,
      numSerie: referencia.numSerie,
      modelo: referencia.modelo,
      eventos,
    };
  });
};

export const fetchEquipamentosRequisicao = async (requisicaoId) => {
  const response = await BaseService.get({
    url: `requisicoes/${encodeURIComponent(requisicaoId)}/equipamentos`,
  });
  const body = response?.data;
  return Array.isArray(body) ? body : [];
};
